// src/app/PrivateRoute3.js
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../UserContext";

export default function PrivateRoute3({ children }) {
  const { user } = useContext(UserContext);

  // Bloque si pas connecté OU rôle = invite
  if (!user || user.role === "invite") {
    return <Navigate to="/login" replace />;
  }

  return children;
}
